import { warn } from "@swivl-mono/helpers";
import { MemberInviteInterface, PulsePersona } from "@swivl-mono/types";
import { Button, ButtonColor, Input } from "@swivl-mono/ui";
import { useState } from "react";

import { isPulseEnabled } from "../../../../Helpers/FeatureFlags/isPulseEnabled";
import { NavigationHelper } from "../../../../Helpers/Navigation/Navigation.Helper";
import { Member } from "../../../../Models/Member/Member.Current";
import MembersModel from "../../../../Models/Member/Members.Model";
import ModalModel from "../../../../Models/Modal/Modal.Model";
import { AlertsModel } from "../../../../Models/Notifications/Alerts.Model";
import { PulsePersonaSelect } from "../Details/PulsePersonaSelect";

export function MembersAddMemberModal() {
  const [partialInvite, setPartialInvite] = useState<Partial<MemberInviteInterface>>({
    email: "",
    firstName: "",
    lastName: "",
    orgId: Member.orgId,
    sentByMemberId: Member.id
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /** A persona also picks the invite's first role, which can be changed on the invite afterwards. */
  const handlePersonaChange = (persona: PulsePersona | null): void => {
    setPartialInvite({ ...partialInvite, persona });
  };

  return (
    <div className="flex flex-col gap-2">
      <Input
        label="First Name"
        error={error}
        value={partialInvite.firstName}
        onChange={(e) => setPartialInvite({ ...partialInvite, firstName: e.target.value })}
      />
      <Input
        error={error}
        label="Last Name"
        value={partialInvite.lastName}
        onChange={(e) => setPartialInvite({ ...partialInvite, lastName: e.target.value })}
      />
      <Input
        error={error}
        label="Email"
        value={partialInvite.email}
        onChange={(e) => setPartialInvite({ ...partialInvite, email: e.target.value })}
      />
      {isPulseEnabled() && <PulsePersonaSelect persona={partialInvite.persona ?? null} onChange={handlePersonaChange} />}

      <div className="mt-5 flex flex-row justify-end pb-3">
        <Button
          loading={loading}
          onClick={() => {
            ModalModel.hideModal();
          }}
          className="mr-2"
        >
          Cancel
        </Button>
        <Button
          color={ButtonColor.ORANGE}
          loading={loading}
          onClick={async () => {
            try {
              if (!partialInvite.email || !partialInvite.firstName || !partialInvite.lastName) {
                setError("Please fill out all fields");
                return;
              }

              const newInvite = await MembersModel.createInvite(partialInvite);
              AlertsModel.successToast("Invite sent");
              ModalModel.hideModal();
              NavigationHelper.navigate("settings/members/invite/" + newInvite.id);
            } catch (error: any) {
              warn(error, error.message);
              if (error.message) {
                setError(error.message);
              }
              setLoading(false);
            }
          }}
        >
          Send Invite
        </Button>
      </div>
    </div>
  );
}
